import { gql } from '@apollo/client';

export const noteFragments = {
  noteItem: gql`
    fragment NoteItem on Note {
      id
      projectId
      parentId
      noteCommodityType
      noteType
      note
      updatedTime
      updatedBy
    }
  `,
};

export const GET_NOTES_BY_COMMODITY = gql`
  ${noteFragments.noteItem}
  query NotesByCommodity($commodityId: ID!, $noteCommodityType: NoteCommodityType!) {
    notesByCommodity(commodityId: $commodityId, noteCommodityType: $noteCommodityType) {
      ...NoteItem
    }
  }
`;

export const SAVE_NOTES = gql`
  ${noteFragments.noteItem}
  mutation SaveNotes($saveNotesInput: SaveNotesInput!) {
    saveNotes(saveNotesInput: $saveNotesInput) {
      notes {
        ...NoteItem
      }
      errors
    }
  }
`;

export const SEARCH_EQUIPMENT_NOTES = gql`
  ${noteFragments.noteItem}
  query SearchEquipmentNotes($searchInput: SearchInput!) {
    searchEquipmentNotes(searchInput: $searchInput) {
      items {
        ...NoteItem
      }
      error
    }
  }
`;
export const SEARCH_JUMPER_NOTES = gql`
  ${noteFragments.noteItem}
  query SearchJumperNotes($searchInput: SearchInput!) {
    searchJumperNotes(searchInput: $searchInput) {
      items {
        ...NoteItem
      }
      error
    }
  }
`;

export const SEARCH_CABLE_NOTES = gql`
  ${noteFragments.noteItem}
  query SearchCableNotes($searchInput: SearchInput!) {
    searchCableNotes(searchInput: $searchInput) {
      items {
        ...NoteItem
      }
      error
    }
  }
`;

export const SEARCH_RACEWAY_NOTES = gql`
  ${noteFragments.noteItem}
  query SearchRacewayNotes($searchInput: SearchInput!) {
    searchRacewayNotes(searchInput: $searchInput) {
      items {
        ...NoteItem
      }
      error
    }
  }
`;

export const SEARCH_CABLE_FROM_TERM_NOTES = gql`
  ${noteFragments.noteItem}
  query SearchCableFromTermNotes($searchInput: SearchInput!) {
    searchCableFromTermNotes(searchInput: $searchInput) {
      items {
        ...NoteItem
      }
      error
    }
  }
`;

export const SEARCH_CABLE_TO_TERM_NOTES = gql`
  ${noteFragments.noteItem}
  query SearchCableToTermNotes($searchInput: SearchInput!) {
    searchCableToTermNotes(searchInput: $searchInput) {
      items {
        ...NoteItem
      }
      error
    }
  }
`;
export const ADD_REVISION_NOTE = gql`
  ${noteFragments.noteItem}
  mutation AddRevisionNote($addRevisionNoteInput: AddRevisionNoteInput!) {
    addRevisionNote(addRevisionNoteInput: $addRevisionNoteInput) {
      notes {
        ...NoteItem
      }
      errors
    }
  }
`;
